module.exports = __webpack_public_path__ + "static/media/undraw_dashboard_nklg.5e09ece6.svg";